import classNames from 'classnames';
import { type ReactNode, useState } from 'react';

import { RevelioTooltip } from '@revelio/ui';

import styles from './impersonationBanner.module.css';

interface ImpersonationBannerOverridesTooltipProps {
  content: ReactNode;
  hasOverrides: boolean;
  label: string;
  value: string;
  size: 'user' | 'client';
}

export function ImpersonationBannerOverridesTooltip({
  content,
  hasOverrides,
  label,
  value,
  size,
}: ImpersonationBannerOverridesTooltipProps) {
  const [placement, setPlacement] = useState<'top' | 'bottom'>('bottom');

  return (
    <RevelioTooltip
      label={<div className={styles.tooltipBody}>{content}</div>}
      placement={placement}
      triggerClassName={styles.chipTrigger}
      className={classNames(
        styles.tooltip,
        size === 'user' ? styles.userTooltip : styles.clientTooltip
      )}
    >
      <div
        className={classNames(
          styles.chip,
          !hasOverrides && styles.chipInactive
        )}
        data-banner-no-drag=""
        onMouseEnter={(event) => {
          const { top } = event.currentTarget.getBoundingClientRect();
          setPlacement(top > window.innerHeight / 2 ? 'top' : 'bottom');
        }}
      >
        {hasOverrides && <div className={styles.chipDot} />}
        <span className={styles.chipText}>
          {label}: {value}
        </span>
      </div>
    </RevelioTooltip>
  );
}
